var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLibrary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56_2872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.51 5.72998H1.21997V6.16998H22.51V5.72998Z",
    fill: "#72ACF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.51 6.53998H1.21997V6.97998H22.51V6.53998Z",
    fill: "#AAC6F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.51 7.34998H1.21997V7.78998H22.51V7.34998Z",
    fill: "#72ACF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.89 9.52H0.769976C0.399976 9.52 0.0999756 9.22 0.0999756 8.85C0.0999756 8.48 0.399976 8.18 0.769976 8.18H20.89C21.68 8.18 22.32 7.54 22.32 6.75C22.32 5.96 21.68 5.32 20.89 5.32H0.769976C0.399976 5.33 0.109976 5.03 0.109976 4.67C0.109976 4.31 0.409976 4 0.779976 4H20.9C22.42 4 23.66 5.24 23.66 6.76C23.66 8.28 22.42 9.52 20.9 9.52H20.89Z",
    fill: "#0A3B87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4 16.78H1.10999V17.22H22.4V16.78Z",
    fill: "#72ACF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4 17.58H1.10999V18.02H22.4V17.58Z",
    fill: "#AAC6F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4 18.39H1.10999V18.83H22.4V18.39Z",
    fill: "#72ACF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.78 20.57H0.67C0.3 20.57 0 20.27 0 19.9C0 19.53 0.3 19.23 0.67 19.23H20.79C21.58 19.23 22.22 18.59 22.22 17.8C22.22 17.01 21.58 16.37 20.79 16.37H0.67C0.3 16.37 0 16.07 0 15.7C0 15.33 0.3 15.03 0.67 15.03H20.79C22.31 15.03 23.55 16.27 23.55 17.79C23.55 19.31 22.31 20.55 20.79 20.55L20.78 20.57Z",
    fill: "#0A3B87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.44 11.26H1.15002V11.7H22.44V11.26Z",
    fill: "#72ACF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.44 12.06H1.15002V12.5H22.44V12.06Z",
    fill: "#AAC6F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.44 12.87H1.15002V13.31H22.44V12.87Z",
    fill: "#72ACF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.77001 15.04H22.89C23.26 15.04 23.56 14.74 23.56 14.37C23.56 14 23.26 13.7 22.89 13.7H2.77001C1.98001 13.7 1.34001 13.06 1.34001 12.27C1.34001 11.48 1.98001 10.84 2.77001 10.84H22.89C23.26 10.84 23.56 10.54 23.56 10.17C23.56 9.8 23.26 9.5 22.89 9.5H2.77001C1.25001 9.52 0.0100098 10.76 0.0100098 12.28C0.0100098 13.8 1.25001 15.04 2.77001 15.04Z",
    fill: "#F28629"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.02997 8.78998L3.30997 8.38998L2.58997 8.78998V6.97998H4.02997V8.78998Z",
    fill: "#AAC6F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.44 14.22L19.72 13.81L19 14.22V12.41H20.44V14.22Z",
    fill: "#AAC6F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56_2872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.65,
    height: 16.57,
    fill: "white",
    transform: "translate(0 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrary);
export default __webpack_public_path__ + "static/media/library.13b155f799b6a56c9654daa9ea652393.svg";
export { ForwardRef as ReactComponent };